<template>
  <v-dialog style="z-index: 9999" v-model="dialog" max-width="420" content-class="glass-dialog-wrapper" persistent>
    <v-card class="glass-dialog-card text-center pa-5">
      <div class="glow-effect-green"></div>

      <v-card-title class="justify-center flex-column pt-4 pb-2 relative z-index-2">
        <div class="icon-ring-green mb-5">
          <v-icon size="42" color="#4CAF50">mdi-car-back</v-icon>
        </div>
        <span class="text-h5 font-weight-black white--text text-shadow leading-tight"> Dein Autokennzeichen </span>
      </v-card-title>

      <v-card-text class="text-body-1 grey--text text--lighten-2 px-2 relative z-index-2">
        <p class="mb-4" style="font-size: 0.95rem">Damit du stressfrei bei uns parken kannst, hinterlege bitte deine Autokennzeichen</p>

        <v-text-field
          v-model="plates[0]"
          label="Kennzeichen 1 (z.B. ZH 12345)"
          outlined
          dark
          color="#4CAF50"
          class="mb-2"
          hide-details="auto"
          prepend-inner-icon="mdi-numeric-1-box"></v-text-field>

        <v-text-field
          v-model="plates[1]"
          label="Kennzeichen 2 (Optional)"
          outlined
          dark
          color="#4CAF50"
          hide-details="auto"
          prepend-inner-icon="mdi-numeric-2-box"></v-text-field>

        <p class="caption grey--text mt-4 mb-0">
          <v-icon x-small color="grey">mdi-information-outline</v-icon>
          Du kannst deine Kennzeichen jederzeit in deinem Profil bearbeiten.
        </p>
      </v-card-text>

      <v-card-actions class="d-flex flex-column align-center pb-4 pt-2 relative z-index-2">
        <div class="d-flex justify-center w-100 mb-2">
          <v-btn rounded text color="grey lighten-1" @click="skip" :disabled="loading"> Später </v-btn>
          <v-btn rounded color="#4CAF50" class="black--text font-weight-bold elevation-5 px-6 ml-3" @click="save" :loading="loading">
            Speichern
          </v-btn>
        </div>

        <v-btn text x-small color="grey darken-1" @click="noCar" :disabled="loading" class="mt-2"> Ich nutze keinen Parkplatz </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "@/api"

export default {
  name: "LicensePlatePopup",
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      plates: ["", ""],
    }
  },
  methods: {
    checkAndShow() {
      console.log("1")
      // Wurden schon Kennzeichen hinterlegt?
      if (this.user && this.user.licensePlates && this.user.licensePlates.length > 0) return

      console.log("2")
      // Hat der User angegeben, dass er kein Auto hat?
      if (localStorage.getItem("licensePlate_no_car") === "true") return

      console.log("3")
      // Hat der User heute schon auf "Später" geklickt?
      const lastSkipped = localStorage.getItem("licensePlate_skipped_date")
      const today = new Date().toDateString()
      console.log("4")
      if (lastSkipped === today) return
      console.log("5")

      // Zeige Dialog
      this.dialog = true
    },
    skip() {
      const today = new Date().toDateString()
      localStorage.setItem("licensePlate_skipped_date", today)
      this.dialog = false
    },
    noCar() {
      // Speichert dauerhaft im LocalStorage, dass der User kein Auto hat
      localStorage.setItem("licensePlate_no_car", "true")
      this.dialog = false
    },
    async save() {
      this.loading = true
      try {
        const payload = this.plates.filter((p) => p.trim() !== "")

        let res = await api.updateLicensePlates(payload)

        if (res.success) {
          this.$toast.success("Kennzeichen erfolgreich gespeichert!")
          this.$emit("updated", res.licensePlates)
          this.dialog = false
        }
      } catch (e) {
        this.$toast.error("Fehler beim Speichern der Kennzeichen.")
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .v-dialog__content {
  z-index: 99999 !important;
}

::v-deep .glass-dialog-wrapper {
  box-shadow: none !important;
  overflow: visible !important;
}

.glass-dialog-card {
  background: rgba(20, 20, 20, 0.85) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 28px !important;
  position: relative;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5) !important;
}

.glow-effect-green {
  position: absolute;
  top: -20%;
  left: 50%;
  transform: translateX(-50%);
  width: 150%;
  height: 60%;
  background: radial-gradient(circle, rgba(76, 175, 80, 0.25) 0%, transparent 70%);
  pointer-events: none;
  z-index: 0;
  filter: blur(30px);
}

.icon-ring-green {
  width: 85px;
  height: 85px;
  border-radius: 50%;
  background: rgba(76, 175, 80, 0.1);
  border: 1px solid rgba(76, 175, 80, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 30px rgba(76, 175, 80, 0.15);
  margin: 0 auto;
}

.z-index-2 {
  position: relative;
  z-index: 2;
}

.text-shadow {
  text-shadow: 0 4px 10px rgba(0, 0, 0, 0.8);
}
.w-100 {
  width: 100%;
}
</style>
